/*
  GRAVITUS — interruttore Griglia/Tabella nelle collezioni di bilance (audit 30/10, c41).

  <gravitus-view-toggle> sta dentro il contenitore della griglia, quindi facets.js lo
  ricrea a ogni filtro: in connectedCallback riapplica la vista scelta (localStorage).
  La tabella e' snippets/gravitus-collection-table.liquid.
*/
(() => {
  if (customElements.get('gravitus-view-toggle')) return;
  const KEY = 'gravitus:collection-view';

  const read = () => {
    try {
      return localStorage.getItem(KEY) === 'table' ? 'table' : 'grid';
    } catch (e) {
      return 'grid';
    }
  };
  const save = (v) => {
    try {
      localStorage.setItem(KEY, v);
    } catch (e) {
      /* storage non disponibile: la scelta vale solo per questa pagina */
    }
  };

  class GravitusViewToggle extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-gview]')];
      this.buttons.forEach((b) => b.addEventListener('click', () => this.apply(b.dataset.gview, true)));
      this.apply(read(), false);
    }

    apply(view, remember) {
      const box = this.closest('.collection');
      if (!box) return;
      const grid = box.querySelector('#product-grid');
      const table = box.querySelector('[data-gview-table]');
      if (!grid || !table) return;
      const isTable = view === 'table';
      grid.hidden = isTable;
      table.hidden = !isTable;
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gview === view)));
      if (remember) save(view);
    }
  }

  customElements.define('gravitus-view-toggle', GravitusViewToggle);
})();
